import React from 'react'
import { motion } from 'framer-motion';

import { useWizard } from 'react-use-wizard'

const variants = {
  enter: (direction) => {
    return {
      //x: direction > 0 ? 800 : -800,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      //x: direction < 0 ? 800 : -800,
      opacity: 0,
    };
  },
};

const StepAnimated = React.memo(
  ({ children, /*previousStep: previousStepIndex, setPreviousStep,*/ bodyRef }) => {
    const { activeStep } = useWizard();

    React.useEffect(() => {
      // if (bodyRef) {
      //   bodyRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      // }
      window.scrollTo({ top: 0, behavior: 'smooth' });

      return () => {
        //previousStepIndex.current = activeStep;
        //setPreviousStep(activeStep)
      };
    }, [/*activeStep, previousStepIndex, setPreviousStep,*/ bodyRef]);

    return (
      <motion.div
        //custom={activeStep - previousStepIndex.current}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30,
        }}
      >
        {children}
      </motion.div>
    );
  },
);

export default StepAnimated;